import { z } from "zod";

export const emissionsPeriods = [
  { id: "DA", label: "DA" },
  { id: "NEXT_MARCH", label: "Next March" },
  { id: "NEXT_DEC", label: "Next December (M)" },
  { id: "NEXT_DEC_PLUS_12M", label: "Next Dec (+1 year)" },
  { id: "NEXT_DEC_PLUS_24M", label: "Next Dec (+2 years)" },
  { id: "NEXT_DEC_PLUS_36M", label: "Next Dec (+3 years)" },
  { id: "NEXT_DEC_PLUS_48M", label: "Next Dec (+4 years)" },
];

export const gasProducts = [
  { id: "TTF_BID", label: "TTF Bid" },
  { id: "TTF_ASK", label: "TTF Ask" },
];

export const gasPeriods = [
  { id: "DA", label: "DA" },
  { id: "WE", label: "WE" },
  { id: "M1", label: "M1" },
  { id: "M2", label: "M2" },
  { id: "M3", label: "M3" },
  { id: "Q1", label: "Q1" },
  { id: "Q2", label: "Q2" },
  { id: "Q3", label: "Q3" },
  { id: "Q4", label: "Q4" },
  { id: "Y1", label: "Y1" },
  { id: "Y2", label: "Y2" },
  { id: "Y3", label: "Y3" },
  { id: "Y4", label: "Y4" },
  { id: "Y5", label: "Y5" },
  { id: "Win1", label: "Win1" },
  { id: "Win2", label: "Win2" },
  { id: "Win3", label: "Win3" },
  { id: "Win4", label: "Win4" },
  { id: "Sum1", label: "Sum1" },
  { id: "Sum2", label: "Sum2" },
  { id: "Sum3", label: "Sum3" },
  { id: "Sum4", label: "Sum4" },
];

export const electricityProducts = [
  { id: "NL_BASE_BID", label: "NL Base Bid" },
  { id: "NL_BASE_ASK", label: "NL Base Ask" },
  { id: "NL_PEAK_BID", label: "NL Peak Bid" },
  { id: "NL_PEAK_ASK", label: "NL Peak Ask" },
];

export const electricityPeriods = [
  { id: "M1", label: "M1" },
  { id: "M2", label: "M2" },
  { id: "M3", label: "M3" },
  { id: "Q1", label: "Q1" },
  { id: "Q2", label: "Q2" },
  { id: "Q3", label: "Q3" },
  { id: "Q4", label: "Q4" },
  { id: "Y1", label: "Y1" },
  { id: "Y2", label: "Y2" },
  { id: "Y3", label: "Y3" },
  { id: "Y4", label: "Y4" },
];

export const sparkSpreadProducts = [
  { id: "SPARKSPREAD_BASE_BID", label: "Spark Spread Base Bid" },
  { id: "SPARKSPREAD_BASE_ASK", label: "Spark Spread Base Ask" },
  { id: "SPARKSPREAD_PEAK_BID", label: "Spark Spread Peak Bid" },
  { id: "SPARKSPREAD_PEAK_ASK", label: "Spark Spread Peak Ask" },
];

export const sparkSpreadPeriods = [
  { id: "M1", label: "M1" },
  { id: "M2", label: "M2" },
  { id: "M3", label: "M3" },
  { id: "Q1", label: "Q1" },
  { id: "Q2", label: "Q2" },
  { id: "Q3", label: "Q3" },
  { id: "Q4", label: "Q4" },
  { id: "Y1", label: "Y1" },
  { id: "Y2", label: "Y2" },
  { id: "Y3", label: "Y3" },
  { id: "Y4", label: "Y4" },
];

export const estimatedPricePreferenceDefaultvalues = {
  emissions: {
    DA: false,
    NEXT_MARCH: false,
    NEXT_DEC: false,
    NEXT_DEC_PLUS_12M: false,
    NEXT_DEC_PLUS_24M: false,
    NEXT_DEC_PLUS_36M: false,
    NEXT_DEC_PLUS_48M: false,
  },
  gas: {
    TTF_BID: {
      DA: false,
      WE: false,
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
      Y5: false,
      Win1: false,
      Win2: false,
      Win3: false,
      Win4: false,
      Sum1: false,
      Sum2: false,
      Sum3: false,
      Sum4: false,
    },
    TTF_ASK: {
      DA: false,
      WE: false,
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
      Y5: false,
      Win1: false,
      Win2: false,
      Win3: false,
      Win4: false,
      Sum1: false,
      Sum2: false,
      Sum3: false,
      Sum4: false,
    },
  },
  electricity: {
    NL_BASE_BID: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    NL_BASE_ASK: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    NL_PEAK_BID: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    NL_PEAK_ASK: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
  },
  sparkspread: {
    IS_LONG_HORIZON: false,
    SPARKSPREAD_BASE_BID: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    SPARKSPREAD_BASE_ASK: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    SPARKSPREAD_PEAK_BID: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
    SPARKSPREAD_PEAK_ASK: {
      M1: false,
      M2: false,
      M3: false,
      Q1: false,
      Q2: false,
      Q3: false,
      Q4: false,
      Y1: false,
      Y2: false,
      Y3: false,
      Y4: false,
    },
  },
};

const emissionsPeriodSchema = z.object({
  DA: z.boolean().default(false),
  NEXT_MARCH: z.boolean().default(false),
  NEXT_DEC: z.boolean().default(false),
  NEXT_DEC_PLUS_12M: z.boolean().default(false),
  NEXT_DEC_PLUS_24M: z.boolean().default(false),
  NEXT_DEC_PLUS_36M: z.boolean().default(false),
  NEXT_DEC_PLUS_48M: z.boolean().default(false),
});

const gasPeriodSchema = z.object({
  DA: z.boolean().default(false),
  WE: z.boolean().default(false),
  M1: z.boolean().default(false),
  M2: z.boolean().default(false),
  M3: z.boolean().default(false),
  Q1: z.boolean().default(false),
  Q2: z.boolean().default(false),
  Q3: z.boolean().default(false),
  Q4: z.boolean().default(false),
  Y1: z.boolean().default(false),
  Y2: z.boolean().default(false),
  Y3: z.boolean().default(false),
  Y4: z.boolean().default(false),
  Y5: z.boolean().default(false),
  Win1: z.boolean().default(false),
  Win2: z.boolean().default(false),
  Win3: z.boolean().default(false),
  Win4: z.boolean().default(false),
  Sum1: z.boolean().default(false),
  Sum2: z.boolean().default(false),
  Sum3: z.boolean().default(false),
  Sum4: z.boolean().default(false),
});

const electricityPeriodSchema = z.object({
  M1: z.boolean().default(false),
  M2: z.boolean().default(false),
  M3: z.boolean().default(false),
  Q1: z.boolean().default(false),
  Q2: z.boolean().default(false),
  Q3: z.boolean().default(false),
  Q4: z.boolean().default(false),
  Y1: z.boolean().default(false),
  Y2: z.boolean().default(false),
  Y3: z.boolean().default(false),
  Y4: z.boolean().default(false),
});
const sparkSpreadPeriodSchema = electricityPeriodSchema;

export const emissionsSchema = emissionsPeriodSchema;

export const gasSchema = z.object({
  TTF_BID: gasPeriodSchema,
  TTF_ASK: gasPeriodSchema,
});

export const electricitySchema = z.object({
  NL_BASE_BID: electricityPeriodSchema,
  NL_BASE_ASK: electricityPeriodSchema,
  NL_PEAK_BID: electricityPeriodSchema,
  NL_PEAK_ASK: electricityPeriodSchema,
});

export const sparkSpreadSchema = z.object({
  SPARKSPREAD_BASE_BID: sparkSpreadPeriodSchema,
  SPARKSPREAD_BASE_ASK: sparkSpreadPeriodSchema,
  SPARKSPREAD_PEAK_BID: sparkSpreadPeriodSchema,
  SPARKSPREAD_PEAK_ASK: sparkSpreadPeriodSchema,
  IS_LONG_HORIZON: z.boolean(),
});

export const estimatedPriceUpdatePreferencesSchema = z.object({
  emissions: emissionsSchema,
  gas: gasSchema,
  electricity: electricitySchema,
  sparkspread: sparkSpreadSchema,
});

// Export configurations for reuse in components
export const PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE = {
  emissions: {
    title: "Emissions [EUR/ton]",
    path: "emissions",
    products: [{ id: "", label: "" }],
    contracts: [
      { id: "DA", label: "DA" },
      { id: "NEXT_MARCH", label: "Next March" },
      { id: "NEXT_DEC", label: "Next December" },
      { id: "NEXT_DEC_PLUS_12M", label: "Next Dec (+1 year)" },
      { id: "NEXT_DEC_PLUS_24M", label: "Next Dec (+2 years)" },
      { id: "NEXT_DEC_PLUS_36M", label: "Next Dec (+3 years)" },
      { id: "NEXT_DEC_PLUS_48M", label: "Next Dec (+4 years)" },
    ],
  },
  gas: {
    title: "Gas [EUR/MWh]",
    path: "gas",
    products: [
      { id: "TTF_BID", label: "TTF Bid" },
      { id: "TTF_ASK", label: "TTF Ask" },
    ],
    contracts: [
      { id: "DA", label: "DA" },
      { id: "WE", label: "WE" },
      { id: "M1", label: "M1" },
      { id: "M2", label: "M2" },
      { id: "M3", label: "M3" },
      { id: "Q1", label: "Q1" },
      { id: "Q2", label: "Q2" },
      { id: "Q3", label: "Q3" },
      { id: "Q4", label: "Q4" },
      { id: "Y1", label: "Y1" },
      { id: "Y2", label: "Y2" },
      { id: "Y3", label: "Y3" },
      { id: "Y4", label: "Y4" },
      { id: "Y5", label: "Y5" },
      { id: "Win1", label: "Win1" },
      { id: "Win2", label: "Win2" },
      { id: "Win3", label: "Win3" },
      { id: "Win4", label: "Win4" },
      { id: "Sum1", label: "Sum1" },
      { id: "Sum2", label: "Sum2" },
      { id: "Sum3", label: "Sum3" },
      { id: "Sum4", label: "Sum4" },
    ],
  },
  electricity: {
    title: "Electricity [EUR/MWh]",
    path: "electricity",
    products: [
      { id: "NL_BASE_BID", label: "NL Base Bid" },
      { id: "NL_BASE_ASK", label: "NL Base Ask" },
      { id: "NL_PEAK_BID", label: "NL Peak Bid" },
      { id: "NL_PEAK_ASK", label: "NL Peak Ask" },
    ],
    contracts: [
      { id: "M1", label: "M1" },
      { id: "M2", label: "M2" },
      { id: "M3", label: "M3" },
      { id: "Q1", label: "Q1" },
      { id: "Q2", label: "Q2" },
      { id: "Q3", label: "Q3" },
      { id: "Q4", label: "Q4" },
      { id: "Y1", label: "Y1" },
      { id: "Y2", label: "Y2" },
      { id: "Y3", label: "Y3" },
      { id: "Y4", label: "Y4" },
    ],
  },
  sparkspread: {
    title: "SparkSpread [EUR/MWh]",
    path: "sparkspread",
    products: [
      { id: "SPARKSPREAD_BASE_BID", label: "Spark Spread Base Bid" },
      { id: "SPARKSPREAD_BASE_ASK", label: "Spark Spread Base Ask" },
      { id: "SPARKSPREAD_PEAK_BID", label: "Spark Spread Peak Bid" },
      { id: "SPARKSPREAD_PEAK_ASK", label: "Spark Spread Peak Ask" },
    ],
    contracts: [
      { id: "M1", label: "M1" },
      { id: "M2", label: "M2" },
      { id: "M3", label: "M3" },
      { id: "Q1", label: "Q1" },
      { id: "Q2", label: "Q2" },
      { id: "Q3", label: "Q3" },
      { id: "Q4", label: "Q4" },
      { id: "Y1", label: "Y1" },
      { id: "Y2", label: "Y2" },
      { id: "Y3", label: "Y3" },
      { id: "Y4", label: "Y4" },
    ],
  },
} as const;

export type ProductConfigForEstimatedPriceUpdate =
  (typeof PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE)[keyof typeof PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE];
